import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Grid,
    Divider,
    Typography,
} from '@material-ui/core';
import Box from '@mui/material/Box';
import { msmSwalInformacion, palette } from "configurations/styles/theme";
import HelpIcon from '@mui/icons-material/Help';
import { DialogTitle } from '@mui/material';
const useStyles = makeStyles(theme => ({
    form: {
        borderWidth: "1px",
        border: "1px solid  #aaaaaa",
        borderRadius: "8px",
        width: "100%",
        padding: "1%"
    },
    button: {
        marginTop: "0.5%",
        width: "80%",
        maxWidth: "80%",
        padding: "0.5%",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: palette.primary.dark,
        borderRadius: "8px",
        "&:hover": {
            color: palette.primary.contrastText,
            background: palette.primary.main
        }
    },
    formControl: {
        marginTop: theme.spacing(0),
        minWidth: 120,
    },
    radio: {
        display: '-webkit-box',
        marginTop: '0px'
    },
    radioLable: {
        color: palette.primary.main,
        display: 'flex'
    },
    radioButton: {
        marginTop: '0px',
        paddingTop: '0px'
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
}));

const StateUser = ({ data = () => { } }) => {
    const classes = useStyles();
    const [company, setCompany] = useState(data);
    const [openLoader, setOpenLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [stateQr, setStateQr] = useState("");
    const [stateAffiliation, setStateAffiliation] = useState("");
    const [openDialogHelpInformation, setOpenUpHelpInformation] = useState(false);
    const [helpInformationPac, setHelpInformationPac] = useState(false);
    const [stateLogos, setStateLogos] = useState("");
    const existError = () => { }

    useEffect(() => {
        if (company.estadoCodigoSeguridadQr == 1) {
            setStateQr("Generado")
        }
        if (company.estadoCodigoSeguridadQr == 2) {
            setStateQr("Anulado")
        }
        if (company.estadoCodigoSeguridadQr == 3) {
            setStateQr("Pendiente")
        }
        if (company.estadoCodigoSeguridadQr == 4) {
            setStateQr("A espera de comunicación con la DGI")
        }
        if (company.estadoAfiliacionPac == 1 || company.estadoAfiliacionPac == 2) {
            setStateAffiliation("Afiliada")
        }
        if (company.estadoAfiliacionPac == 3) {
            setStateAffiliation("Pendiente")
        }
        if (company.estadoAfiliacionPac == 4) {
            setStateAffiliation("A espera de comunicación con la DGI")
        }
        if (company.logo != null && company.logoCafe != null) {
            setStateLogos("Completo")
        } else {
            setStateLogos("Pendiente")
        }
    }, [company]);

    const handleClickHelpInformationQr = () => {
        setOpenUpHelpInformation(true);
        setOpen(false);
    };

    const handleClickHelpPac = () => {
        msmSwalInformacion(
            "Estado de afiliación al PAC",
            "AFILIADO: La empresa se encuentra afiliada al PAC de forma satisfactoria." + " " +
            "PENDIENTE: La empresa aún no se encuentra afiliada al PAC." + " " +
            "A ESPERA: se encuentra en espera de una respuesta de la DGI."
        );
    };

    const handleClickHelpQrCode = () => {
        msmSwalInformacion(
            "Estado del código de seguridad QR",
            "GENERADO: el código de seguridad ya fue creado en la DGI." + " " +
            "ANULADO: el código de seguridad ya fue anulado en la DGI." + " " +
            "PENDIENTE: no se ha realizado ninguna acción entorno al código de seguridad en la DGI." + " " +
            "A ESPERA: se encuentra en espera de una respuesta de la DGI."
        );
    };

    const handleClickHelpLogo = () => {
        msmSwalInformacion(
            "Estado de carga de logos",
            "COMPLETO: los logos de la empresa se encuentran cargados al sistema." + " " +
            "PENDIENTE: los logos de la empresa se encuentran pendientes de cargar."
        );
    };

    const handleCloseDialogHelpInformation = () => {
        setOpenUpHelpInformation(false);
    }

    return (
        <Box className={classes.form} >
            <div class="row form-group">
                <div class="col-sm-12 mb-1">
                    <h5>Estado de la empresa</h5>
                    <label>Los campos marcados con (  <font color={palette.error.main}> *</font> )son obligatorios para el sistema de facturación electrónica:</label>
                </div>
                <div class="col-sm-6 mb-1">
                    <label>Código de seguridad QR <font color={palette.error.main}> *</font>:</label>
                </div>
                <div class="col-sm-5 mb-1">
                    <input class="form-control" disabled
                        value={stateQr}
                    />
                </div>
                <div class="col-sm-0 mb-1">
                    <HelpIcon onClick={handleClickHelpQrCode}>
                    </HelpIcon>
                </div>
                <div class="col-sm-6 mb-1">
                    <label>Afiliación al PAC <font color={palette.error.main}> *</font>:</label>
                </div>
                <div class="col-sm-5 mb-1">
                    <input class="form-control" disabled
                        value={stateAffiliation}
                    />
                </div>
                <div class="col-sm-0 mb-1">
                    <HelpIcon onClick={handleClickHelpPac}>
                    </HelpIcon>
                </div>
                <div class="col-sm-6 mb-1">
                    <label>Carga de logos :</label>
                </div>
                <div class="col-sm-5 mb-1">
                    <input class="form-control" disabled
                        value={stateLogos}

                    />
                </div>
                <div class="col-sm-0 mb-1">
                    <HelpIcon onClick={handleClickHelpLogo}></HelpIcon>
                </div>
            </div>
            <Dialog
                open={openDialogHelpInformation}
                onClose={handleCloseDialogHelpInformation}
            >
                <DialogTitle>Estado del código de seguridad QR</DialogTitle>
                <Divider></Divider>
                <DialogContent>
                    <DialogContentText>
                        <Grid container align="left">
                            <Typography
                                aling="center"
                                variant="h3"
                            >
                                Generado: el código de seguridad ya fue creado en la DGI.
                                <br></br>
                                Anulado: el código de seguridad ya fue anulado en la DGI.
                                <br></br>
                                Pendiente: no se ha realizado ninguna acción entorno al código de seguridad en la DGI.
                                <br></br>
                                A espera: se encuentra en espera de una respuesta de la DGI.
                            </Typography>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item md={6} align="center">
                            <Button color="secondary" variant="outlined" onClick={handleCloseDialogHelpInformation}>
                                Cancelar
                            </Button>
                        </Grid>

                    </Grid>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default StateUser;